export default "__VITE_ASSET__C$NZa9ZM__"